import React from 'react';
import { ReactEditor } from 'slate-react';
import { DropTarget } from '../../components/DropTarget/DropTarget';
import { AulaPlugin } from '../plugins';

/**
 * rootElement plugin
 *
 * Must be used to render highest element in the tree
 */
export const rootElement: AulaPlugin = (editableProps, editor, context) => ({
  ...editableProps,
  renderElement: (props) => {
    if (editableProps.renderElement == null) {
      throw new Error('spacer plugin cannot be first renderElement method');
    }

    const { element } = props;
    const isReadOnly = ReactEditor.isReadOnly(editor);

    const path = ReactEditor.findPath(editor, element);
    const content = editableProps.renderElement(props);

    /**
     * return just the content if this is not a root element
     * or if we're rendering in read only mode
     */
    if (path.length > 1 || isReadOnly) {
      return content;
    }

    return (
      <DropTarget
        data-testid="root-element"
        data-slate-root
        draggable={context?.draggingElement === element}
      >
        {content}
      </DropTarget>
    );
  },
});
